import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {selectLandscapeSmallWebView} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import {FONT_FAMILY_REGULAR, norcatAppColor, white} from '../../utils/utils';

const CustomToast = ({message}) => {
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   return (
      <View style={styles.container}>
         <Text
            style={[
               styles.message,
               {
                  // transform: isLandscapeSmallWebView ? 'rotate(90deg)' : null,
                  // top: isLandscapeSmallWebView ? '-90vh' : null,
               },
            ]}>
            {message}
         </Text>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      width: '100%',
      height: '100%',
      backgroundColor: norcatAppColor,
      padding: 10,
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      zIndex: 9999,
      transform: 'translate3d(0, 0, 0)',
   },
   message: {
      color: white,
      fontSize: 16,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
});

export default CustomToast;
